import icon1 from '../images/service/icon/buildings1.svg'
import icon2 from '../images/service/icon/dining-room1.svg'
import icon3 from '../images/service/icon/living-room1.svg'
import icon4 from '../images/service/icon/planning1.svg'
import icon5 from '../images/service/icon-2/1.svg'
import icon6 from '../images/service/icon-2/2.svg'
import icon7 from '../images/service/icon-2/3.svg'
import icon8 from '../images/service/icon-2/4.svg'
import icon9 from '../images/service/icon-2/5.svg'
import icon10 from '../images/service/icon-2/6.svg'
import icon11 from '../images/service/icon/town1.svg'
import icon12 from '../images/service/icon/urban-planning1.svg'
import icon13 from '../images/service/icon/social-care1.svg'
import icon14 from '../images/service/icon/planning1.svg'
import icon15 from '../images/service/icon-4/excavator.svg'
import icon16 from '../images/service/icon-4/contractor.svg'
import icon17 from '../images/service/icon-4/excavator.svg'
import icon18 from '../images/service/icon-4/property.svg'

import sSimg1 from '../images/service-single/1-.jpg'
import sSimg2 from '../images/service-single/2.jpg'
import sSimg3 from '../images/service-single/3-.jpg'
import sSimg4 from '../images/service-single/des.jpg'
import sSimg5 from '../images/service-single/5.jpg'
import sSimg6 from '../images/service-single/6.jpg'
import sSimg7 from '../images/service-single/7.jpg'
import sSimg8 from '../images/service-single/8.jpg'
import sSimg9 from '../images/service-single/9.jpg'
import sSimg10 from '../images/service-single/10.jpg'
import sSimg11 from '../images/service-single/land.jpg'
import sSimg12 from '../images/service-single/12.jpg'
import sSimg13 from '../images/service-single/13.jpg'
import sSimg14 from '../images/service-single/14.jpg'
import sSimg15 from '../images/service-single/15.jpg'
import sSimg16 from '../images/service-single/16.jpg'
import sSimg17 from '../images/service-single/17.jpg'
import sSimg18 from '../images/service-single/18.jpg'


const Services = [
   {
  Id: '01',
  Icon: icon1,
  SImg: sSimg1,
  title: 'Architectural',
  Subtitle: 'Architectural Services',
  slug: 'architectural',
  description:
    'Design Services provides complete architectural solutions including planning, detailed drawings, approvals, and regulatory documentation for residential, commercial, and institutional projects.',
},
{
  Id: '02',
  Icon: icon3,
  SImg: sSimg3,
  title: 'Interiors',
  Subtitle: 'Interior Design Services',
  slug: 'interiors',
  description:
    'Interiors offers end-to-end interior and exterior design solutions with a perfect blend of aesthetics and functionality, delivered by an experienced team of designers, engineers, and skilled professionals.',
},
 {
  Id: '03',
  Icon: icon4,
  SImg: sSimg4,
  title: 'Design & Planning',
  Subtitle: 'Design & Planning Services',
  slug: 'design-planning',
  description:
    'Comprehensive design and planning services covering space planning, layout optimization, material selection, and technical coordination to ensure efficient, functional, and well-executed projects.',
},

  {
  Id: '04',
  Icon: icon11,
  SImg: sSimg11,
  title: 'Landscaping',
  Subtitle: 'Landscaping Services',
  slug: 'landscaping',
  description:
    'Landscaping Services delivers complete landscape design and development solutions, from concept planning and plant selection to execution, for residential and commercial spaces.',
}
,
   {
      Id: '05',
      Icon: icon5,
      SImg: sSimg5,
      title: 'Design & Planning',
      Subtitle: 'Design & Planning',
      slug: 'Design-Planning-2',
      description: 'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
   },
   {
      Id: '06',
      Icon: icon6,
      SImg: sSimg6,
      title: 'Interior Design',
      Subtitle: 'Interior Design',
      slug: 'InteriorDesign-2',
      description: 'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
   },
   {
      Id: '07',
      Icon: icon7,
      SImg: sSimg7,
      title: 'Custom Solutions',
      Subtitle: 'Custom Solutions',
      slug: 'Custom-Solutions-2',
      description: 'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
   },
   {
      Id: '08',
      Icon: icon8,
      SImg: sSimg8,
      title: 'Architectural Design',
      Subtitle: 'Architectural Design',
      slug: 'Architectural-Design',
      description: 'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
   },
   {
      Id: '09',
      Icon: icon9,
      SImg: sSimg9,
      title: 'Design & Planning',
      Subtitle: 'Design & Planning',
      slug: 'DesignPlanning21',
      description: 'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
   },
   {
      Id: '10',
      Icon: icon10,
      SImg: sSimg10,
      title: 'Power Managemnet',
      Subtitle: 'Power Managemnet',
      slug: 'Power-Managemnet22',
      description: 'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
   },
   
   {
      Id: '11',
      Icon: icon11,
      SImg: sSimg11,
      title: 'Urban Design',
      Subtitle: 'Urban Design',
      slug: 'Power-Managemnet23',
      description: 'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
   },
   {
      Id: '12',
      Icon: icon12,
      SImg: sSimg12,
      title: 'Environmental Planning',
      Subtitle: 'Environmental Planning',
      slug: 'Power-Managemnet24',
      description: 'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
   },
   {
      Id: '13',
      Icon: icon13,
      SImg: sSimg13,
      title: 'Community Engagement',
      Subtitle: 'Community Engagement',
      slug: 'Power-Managemnet25',
      description: 'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
   },
   {
      Id: '14',
      Icon: icon14,
      SImg: sSimg14,
      title: 'Master Planning',
      Subtitle: 'Master Planning',
      slug: 'Master-Planning',
      description: 'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
   },
   {
      Id: '15',
      Icon: icon1,
      SImg: sSimg1,
      title: 'Architectural',
      Subtitle: 'Architectural Services',
      slug: 'architectural',
      description: 'Design Services provides complete architectural solutions including planning, detailed drawings, approvals, and regulatory documentation for residential, commercial, and institutional projects.',
   },
   {
      Id: '16',
      Icon: icon3,
      SImg: sSimg3,
      title: 'Interiors',
      Subtitle: 'interiors Services',
      slug: 'interiors',
      description: 'Interiors offers end-to-end interior and exterior design solutions with a perfect blend of aesthetics and functionality, delivered by an experienced team of designers, engineers, and skilled professionals.',
   },
   {
      Id: '17',
      Icon: icon4,
      SImg: sSimg4,
      title: 'Design & Planning',
      Subtitle: 'Design & Planning Services',
      slug: 'design-planning',
      description: 'Comprehensive design and planning services covering space planning, layout optimization, material selection, and technical coordination to ensure efficient, functional, and well-executed projects.',
   },
   // {
   //    Id: '18',
   //    Icon: icon11,
   //    SImg: sSimg11,
   //    title: 'Landscaping',
   //    Subtitle: 'Landscaping Services',
   //    slug: 'Landscaping',
   //    description: 'Landscaping Services delivers complete landscape design and development solutions, from concept planning and plant selection to execution, for residential and commercial spaces.',
   // },
   // {
   //    Id: '18',
   //    Icon: icon4,
   //    SImg: sSimg4,
   //    title: 'Design & Planning',
   //    Subtitle: 'Design & Planning Services',
   //    slug: 'design-planning',
   //    description: 'Comprehensive design and planning services covering space planning, layout optimization, material selection, and technical coordination to ensure efficient, functional, and well-executed projects.',
   // },
   

]

export default Services;